const RECEIVABLES_TABS_NUMBER = {
  MOVEMENTS: 0,
  COLLECT_LOCAL_PAYMENT: 1,
};

export default RECEIVABLES_TABS_NUMBER;
